import { ExportTypeEnum, PagedResult } from "@king-ict/eupisi-ui/models";
import { api } from "@king-ict/eupisi-ui/utils/apiUtils";

import { SaveResult } from "../../models";
import { Announcement, AnnouncementSearch } from "../../models/Announcement";

const apiUrlPrefix: string = "announcement";

export const getAnnouncementList = async () => {
    return api.get(
        `${apiUrlPrefix}/get`
    ) as Promise<Announcement[]>
}

export const getAnnouncementById = async (id: number) => {
    return api.get(
        `${apiUrlPrefix}/item/${id}`
    ) as Promise<Announcement>
}

export const searchAnnouncement = async (search: AnnouncementSearch) => {
    return api.post(
        `${apiUrlPrefix}/search`,
        search
    ) as Promise<PagedResult<Announcement>>
}

export const saveAnnouncement = async (item: Announcement) => {
    return api.put(
        `${apiUrlPrefix}/save`,
        item
    ) as Promise<SaveResult<Announcement>>
}

export const deleteAnnouncement = async (id: number) => {
    return api.delete(
        `${apiUrlPrefix}/delete/${id}`
    ) as Promise<boolean>
}

export const getAnnouncementDocumentById = async (id: number) => {
    return api.download(
        `${apiUrlPrefix}/document/${id}`
    ) as Promise<any>
}

export const getAnnouncementListExport = async (search: AnnouncementSearch, type: ExportTypeEnum) => {
    return api.download(
        `${apiUrlPrefix}/export/${type}`,
        "post",
        search
    ) as Promise<any>
}
